module.exports = __webpack_public_path__ + "h5/img/index-books.d98fe7b1.png";